import { useFeatureFlags } from 'utils/features';

export default function usePhotosViewCollectionPermissionEnabled() {
  return useFeatureFlags('PHOTOS_VIEW_COLLECTION_PERMISSION');
}